import * as Vue from "vue";
import {Component} from "vue-property-decorator";
import "./landing.styl";
const template = require("./landing.vue");

@Component({
  template: template
})
export class LandingComponent extends Vue {

}

Vue.component("cmLanding", LandingComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/views/landing/landing.ts